// extracted by mini-css-extract-plugin
export default {"textGroup":"TextGroup_textGroup__eW2SI","topText":"TextGroup_topText__O99Hj","bottomText":"TextGroup_bottomText__xPgte"};